export default "__VITE_ASSET__BxgCy1QE__"